import { CORE_RU, CORE_EN, CORE_ES } from './core';
import { EXTENDED_RU, EXTENDED_EN, EXTENDED_ES } from './extended';
import { AUTH_RU, AUTH_EN, AUTH_ES } from './auth';
import { PROFILE_EXTRA_RU, PROFILE_EXTRA_EN, PROFILE_EXTRA_ES } from './profileExtra';
import { SURFACES_RU, SURFACES_EN, SURFACES_ES } from './surfaces';
import { WORKOUTS_UI_RU, WORKOUTS_UI_EN } from './workoutsUi';
import { WORKOUTS_UI_ES } from './workoutsUi.es';
import { TRAINER_SCREENS_RU, TRAINER_SCREENS_EN } from './trainerScreens';
import { TRAINER_SCREENS_ES } from './trainerScreens.es';
import { CLIENT_PROFILE_RU, CLIENT_PROFILE_EN } from './clientProfile';
import { CLIENT_PROFILE_ES } from './clientProfile.es';
import { TRAINER_FORMS_RU, TRAINER_FORMS_EN } from './trainerForms';
import { TRAINER_FORMS_ES } from './trainerForms.es';
import { EXERCISE_STANDARD_EN } from './exerciseStandard.en';
import { EXERCISE_STANDARD_ES } from './exerciseStandard.es';
import { PRIVACY_RU, PRIVACY_EN, PRIVACY_ES } from './privacy';
import { TOS_RU, TOS_EN, TOS_ES } from './termsOfService';
import {
  ACCOUNT_DELETION_RU,
  ACCOUNT_DELETION_EN,
  ACCOUNT_DELETION_ES,
} from './accountDeletion';

function merge(...objects) {
  return objects.reduce((acc, o) => ({ ...acc, ...o }), {});
}

export const MESSAGES = {
  ru: merge(
    CORE_RU,
    EXTENDED_RU,
    AUTH_RU,
    PROFILE_EXTRA_RU,
    SURFACES_RU,
    WORKOUTS_UI_RU,
    TRAINER_SCREENS_RU,
    CLIENT_PROFILE_RU,
    TRAINER_FORMS_RU,
    PRIVACY_RU,
    TOS_RU,
    ACCOUNT_DELETION_RU
  ),
  en: merge(
    CORE_EN,
    EXTENDED_EN,
    AUTH_EN,
    PROFILE_EXTRA_EN,
    SURFACES_EN,
    WORKOUTS_UI_EN,
    TRAINER_SCREENS_EN,
    CLIENT_PROFILE_EN,
    TRAINER_FORMS_EN,
    EXERCISE_STANDARD_EN,
    PRIVACY_EN,
    TOS_EN,
    ACCOUNT_DELETION_EN
  ),
  es: merge(
    CORE_ES,
    EXTENDED_ES,
    AUTH_ES,
    PROFILE_EXTRA_ES,
    SURFACES_ES,
    WORKOUTS_UI_ES,
    TRAINER_SCREENS_ES,
    CLIENT_PROFILE_ES,
    TRAINER_FORMS_ES,
    EXERCISE_STANDARD_ES,
    PRIVACY_ES,
    TOS_ES,
    ACCOUNT_DELETION_ES
  ),
};

function interpolate(template, vars) {
  if (!template || !vars) return template;
  return String(template).replace(/\{(\w+)\}/g, (_, k) =>
    vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : ''
  );
}

/**
 * @param {string} locale 'ru' | 'en' | 'es'
 * @param {string} key
 * @param {Record<string, string|number>|undefined} vars
 */
export function translateKey(locale, key, vars) {
  const chain =
    locale === 'es' ? ['es', 'en', 'ru'] : locale === 'en' ? ['en', 'ru'] : ['ru'];
  for (const loc of chain) {
    const str = MESSAGES[loc]?.[key];
    if (str !== undefined && str !== null) {
      return interpolate(str, vars);
    }
  }
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('[i18n] missing key:', key);
  }
  return key;
}
